import Step2View from "components/view/resetpw/step2";

const Step2Page = () => {
  return <Step2View />;
};

export default Step2Page;
